import BaseApiClient from '../BaseApiClient';
// import { ListDataParams, ListDataResponse } from '../types';
import {
  MembershipInterface,
  ActivateSubscribeInterface,
  MembershipPageSubscription,
  BillingHistoryInterface,
  BillingHistorySelectedId
} from '@interfaces/Membership.interface';
import { ListDataParams, ListDataResponse } from '@api-client/types';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { handleFilters } from '../../utils/billingHistoryFilters';

export class ApiMembership extends BaseApiClient {
  /**
   * Get list of items
   */
  async storeSubscribe(): Promise<MembershipInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .post('/flightdeck-passport')
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async activateSubscribe(body: ActivateSubscribeInterface) {
    return new Promise((resolve, reject) => {
      this.client
        .put('/flightdeck-passport', body)
        .then((res) => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  }

  async cancelSubscription() {
    return new Promise((resolve, reject) => {
      this.client.delete('/flightdeck-passport').catch((err) => reject(err));
    });
  }

  async invoicelist(
    listData: ListDataParams,
    searchTerm?: string
  ): Promise<ListDataResponse<BillingHistoryInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .getList('/flightdeck-passport/invoices')
        .then((res) => {
          // THIS HAD TO BE CREATED AS THE BE FILTERS WONT WORK AS IT GOES THROUGH STRIPE
          if (res.data && res.data.invoices) {
            const page = listData.page;
            const perPage = listData.perPage;
            const total = res.data?.invoices?.length;
            const startIndex = (page - 1) * perPage;
            const endIndex = startIndex + perPage;

            // This handles the pagination
            let slicedInvoices = res.data.invoices.slice(startIndex, endIndex);
            if (searchTerm) {
              slicedInvoices = slicedInvoices.filter(
                (invoice: BillingHistoryInterface) =>
                  invoice.number.includes(searchTerm)
              );
            }
            // this handles the filters
            if (Object.keys(listData?.filters || {}).length > 0) {
              slicedInvoices = handleFilters(
                listData.filters,
                res.data.invoices
              );
            }
            resolve({
              items: slicedInvoices,
              pagination: {
                page,
                perPage,
                total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async emailInvoice(invoiceId: string | number): Promise<MembershipInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .post(`/flightdeck-passport/invoices/${invoiceId}/send`)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async downloadInvoices(
    selectedList?: BillingHistorySelectedId[]
  ): Promise<AxiosResponse> {
    const config: AxiosRequestConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: '/flightdeck-passport/invoices/download',
      headers: {
        // Accept both PDF and ZIP to allow server to choose correct type
        Accept: 'application/pdf, application/zip'
      },
      responseType: 'arraybuffer',
      data: selectedList
        ? {
            data: selectedList
          }
        : {}
    };

    // return await axios.request(config);

    return new Promise((resolve, reject) => {
      this.client
        .request(config)
        .then((res) => {
          if (res.data) {
            resolve(res);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Get subscription
   */
  //  when i know what data im getting ill change its type
  async subscription(): Promise<MembershipPageSubscription> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/flightdeck-passport')
        .then((res) => {
          if (res.data.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { membershipQueryKeys } from './query-keys';
export type { MembershipInvoiceListQueryParams } from './query-keys';
export {
  useMembershipInvoiceListQuery,
  useMembershipSubscriptionQuery
} from './use-membership-queries';
export {
  useMembershipStoreSubscribeMutation,
  useMembershipActivateSubscribeMutation,
  useMembershipCancelSubscriptionMutation,
  useMembershipEmailInvoiceMutation,
  useMembershipDownloadInvoicesMutation
} from './use-membership-mutations';
